import { ParticipantState } from '@castoredc/castor_prose';

// Shared decoder for the participation's stored participant state: base64
// protobuf → ParticipantState. Used by the web schedule layer and the cloud
// functions, mirroring the server-side encodeParticipantState boundary.
//
// Throws on malformed base64 or an undecodable protobuf; callers must catch
// (the schedule layer degrades to an empty schedule; the functions map it to a
// failed-precondition error).
export const decodeParticipantState = (base64: string): ParticipantState => {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return ParticipantState.decode(bytes);
};
